import styled from 'styled-components';
import { Paper, Select, TextField, Button, CircularProgress, Backdrop } from '@material-ui/core';

export const ContainerLogin = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height:100%
`

export const PaperForm = styled(Paper)`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  width: 100%;
  align-self: center;
  padding: 20px 50px;
`

export const Titulo = styled.h2`
  text-align:center;
  margin: 10px 0;
  color: var(--primary);
`

export const Dropdown = styled(Select)`
`

export const ContainerInput = styled.div`
  margin-top: 5px;
`

export const InputText = styled(TextField)`
  width: 100%;
  color: var(--primary);

  .MuiInput-underline:after {
    border-bottom: solid 2px var(--primary);
  }
`


export const ButtonColor = styled(Button)`
  && {
    margin-left: 10px;
    margin-top: 10px;
    background-color: ${props => props.bgColor ? props.bgColor : 'var(--primary)'} ;
    color: ${props => props.txtColor ? props.txtColor : 'var(--white)'};

    :hover {
      background-color: ${props => props.bgColor ? props.bgColor : 'var(--primary)'} ;
      color: ${props => props.txtColor ? props.txtColor : 'var(--white)'};
      box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);
    }
  }
`

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const Loading = styled(CircularProgress)`
  && {
    color: var(--primary);
  }
`

export const BackgroundLoadind = styled(Backdrop)`
  && {
    z-index: 2;
  }
`